/**
 * Cache wrapper for the Rigs list. TtlCache (15-min, single "all" entry, in-flight coalescing)
 * around `API.Data.Rigs.get.all()`. Rigs are global reference data that change rarely, so a shared
 * cache spares every consumer (and every remount) a fresh fetch.
 */

import { Rig } from "@domain/CRM/rig";
import { TtlCache } from "../../../cache/ttlCache";
import { API } from "../../../api";

const LIST_TTL_MS = 15 * 60 * 1000;
const LIST_KEY = "all" as const;

class CachedRigsList {
	private cache = new TtlCache<typeof LIST_KEY, Rig[]>(LIST_TTL_MS, () => API.Data.Rigs.get.all());

	/** Synchronous TTL cache hit, or null if missing/expired. */
	public peek(): Rig[] | null {
		return this.cache.peek(LIST_KEY);
	}

	public get(): Promise<Rig[]> {
		return this.cache.get(LIST_KEY);
	}

	public clear(): void {
		this.cache.clear();
	}
}

export class CachedRigsAPI {
	public list = new CachedRigsList();
}
